import styles from './CoreOperation.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import WaitLoader from "../../WaitLoader/WaitLoader";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {use, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import useLongTask from "../../Util/LongTaskItem/UseLongTask";
import LoggerItem, {ILoggerItem} from "../../FormTemplate/LoggerItem/LoggerItem";
export default function CoreOperation()
{
    const stateRef = useRef<ErrorLineItemRef>(null)

    const loggerRef = useRef<ILoggerItem>(null)

    const [work, setWork] = useState(false)
    const [workName, setWorkName] = useState("")

    const [ldrSimSync,rsSimSync,exSimSync] = useApiQuery("/core/sim/sync","post",useRef(null));
    const [ldrSimVolume,rsSimVolume,exSimVolume] = useApiQuery("/core/sim/volume","post",useRef(null));
    const [ldrLockSync,rsLockSync,exLockSync] = useApiQuery("/core/lock/sync","post",useRef(null));


    const [ldrPaymentRestart,rsPaymentRestart,exPaymentRestart] = useApiQuery("/payment/restart","get",useRef(null));


    const [ldrSyncBase,rsSyncBase,exSyncBase] = useApiQuery("/core/sync","get",useRef(null));
    const [ldrBillCircle,rsBillCircle,exBillCircle] = useApiQuery("/core/circle","get",useRef(null));



    const [ldrBotReload,rsBotReload,exBotReload] = useApiQuery("/core/bot/reload","get",useRef(null));


    const [ldrReportCheck,rsReportCheck,exReportCheck] = useApiQuery("/core/report/check","get",useRef(null));

    const [cnt, setCnt] = useState(0)

    const [ldrSimActivateTask, exSimActivateTask] = useLongTask(100,5000, (state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),(state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),false)


    const onResultTaskTick = (state: boolean, data:any , code:number ,cnt: number)=>{
        setCnt(cnt)
        if(data && Array.isArray(data) && loggerRef.current)loggerRef.current.log(data)
        if(state)
        {
            if(stateRef.current)stateRef.current.show("Задача выполнена", false,0)
            setWork(false)
            return
        }


    }

    const startWork = (name:string    ) =>{
        setCnt(0)
        setWork(true)
        if(loggerRef.current)loggerRef.current.clear()
        if(stateRef.current)stateRef.current.clear()
        setWorkName(name)
    }



    const handleSyncBase = () =>{
        startWork("Синхронизация баз данных")
        exSyncBase().then((e)=>{
            if(e?.success)
            {
                if(stateRef.current)stateRef.current.show( "Задача выполнена" ,false,0)
                setWork(false)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        })
    }
    const handleCircle = () =>{
        startWork("Выполнить билинговый цикл")
        exBillCircle().then((e)=>{


            if(e?.success)
            {
                exSimActivateTask(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        })
    }

    const handleSimSync = () =>{
        startWork("Синхронизация номеров")
        exSimSync().then((e)=>{
            if(e?.success)
            {
                exSimActivateTask(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        })
    }


    const handleSimVolume = () =>{
        startWork("Считывание объемов")
        exSimVolume().then((e)=>{
            if(e?.success)
            {
                exSimActivateTask(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        })
    }


    const handleSyncLock = () =>{
        startWork("Синхронизация локов")
        exLockSync().then((e)=>{
            if(e?.success)
            {
                exSimActivateTask(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        })
    }

    const handlePayReload = ()=>{
        exPaymentRestart().then((e)=>{
            if(e?.success)
            {
                if(stateRef.current)stateRef.current.show("Агент перезапущен" ,false,3000)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
        })
    }

    const handleBotReload = ()=>{
        exBotReload().then((e)=>{
            if(e?.success)
            {
                if(stateRef.current)stateRef.current.show("Боты перезапущены" ,false,3000)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
        })
    }

    const handleReportCheck = () =>{
        startWork("Проверить отчет")
        exReportCheck().then((e)=>{
            if(e?.success)
            {
                exSimActivateTask(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        })
    }



    return(
        <div className={styles.mainCont}>
            <MainFormTemplate title={"Операции"} maxWidth={"1200px"}>
                <div className={"row"}>
                    <div className={styles.ldrCont}>
                        <div className={styles.ldrTitle}>Прогресс работы</div>
                        <div className={styles.ldr}>
                            <WaitLoader loading={work} api={rsSimSync} onlyLoading={true}>

                            </WaitLoader>
                            {work && <div className={styles.cntCont}>{cnt}</div>}
                        </div>
                        {work && <div className={styles.ldrTitle}>«{workName}»</div>}

                    </div>
                </div>

                <div className={"row mb-1"}>
                    <div className={"col-md-3"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={handleSimSync}
                            >Синхронизировать номера</button>


                        </div>

                    </div>
                    <div className={"col-md-3"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={handleSyncBase}
                            >Синхронизировать базы</button>


                        </div>

                    </div>
                    <div className={"col-md-3"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={handleSyncLock}
                            >Синхронизировать локи</button>


                        </div>

                    </div>
                    <div className={"col-md-3"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={handleCircle}
                            >Выполнить билинговый цикл</button>


                        </div>

                    </div>
                </div>
                <div className={"row mb-1"}>
                    <div className={"col-md-3"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={handleReportCheck}
                            >Проверить отчет</button>


                        </div>

                    </div>
                    <div className={"col-md-3"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={handleSimVolume}
                            >Считать объемы</button>


                        </div>

                    </div>
                    <div className={"col-md-3"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={handlePayReload}
                            >Перезапустить  платежного агента</button>


                        </div>

                    </div>
                    <div className={"col-md-3"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={work}
                                    onClick={handleBotReload}
                            >Перезапустить  ботов</button>


                        </div>

                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-sm-12 d-flex align-self-center"}>
                        <LoggerItem lineCount={10} ref={loggerRef} title={"Лог"}></LoggerItem>
                    </div>

                </div>

                <div className={"row"}>
                    <ErrorLineItem ref={stateRef}></ErrorLineItem>
                </div>






            </MainFormTemplate>
        </div>
    )
}